<template>
  <v-card class="pa-4 ma-0 d-flex flex-column gap-3" style="height: 350px" outlined>
    <!-- Header -->
    <v-container class="chart-header d-flex justify-space-between pa-0 ma-0">
      <v-card-text class="text-body-1 ma-0 pa-0">
        {{ $t("alerts_and_insights") }}
      </v-card-text>
      <v-icon color="warning" class="pa-0 ma-0">mdi-flash</v-icon>
    </v-container>

    <!-- Items -->
    <v-container
      v-for="(item, index) in alerts"
      :key="index"
      class="d-flex align-start mb-4 ma-0 pa-0"
    >
      <!-- Icon -->
      <v-avatar v-if="hasData" size="40" :color="item.bgColor" class="ml-3">
        <v-icon :color="item.iconColor" size="20">
          {{ item.icon }}
        </v-icon>
      </v-avatar>

      <!-- Text -->
      <v-container v-if="hasData" class="pa-0 ma-0">
        <v-card-text class="text-body-1 ma-0 pa-0">
          {{ item.title }}
        </v-card-text>
        <v-card-text class="text-body-2 grey--text ma-0 pa-0">
          {{ item.description }}
        </v-card-text>
      </v-container>
    </v-container>
    <v-container
      v-if="!hasData"
      class="pa-0 ma-0 d-flex flex-column align-center justify-center"
      style="height: 337px"
    >
      <img
        :src="require('@/assets/dashboard/no-data(3).png')"
        max-width="100"
        height="100"
        contain
        class="mb-3"
      />
      <v-card-text class="text-body-2 grey--text text-center">
        {{ $t("nothing-for-render") }}
      </v-card-text>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "DashboardAlerts",
  props: {
    purchaseData: {
      type: Object,
      required: true,
    },
    sellData: {
      type: Object,
      required: true,
    },
    costData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      totalStocks: null,
    };
  },
  computed: {
    hasData() {
      return this.alerts.length > 0;
    },
    alerts() {
      return [
        this.buildAlert("عملکرد فروش", this.sellData),
        this.buildAlert("عملکرد خرید", this.purchaseData),
        this.buildAlert("عملکرد هزینه‌ها", this.costData),
        //   {
        //     title: "موجودی کم",
        //     description: `${
        //       this.totalStocks > 0 ? this.totalStocks : 0
        //     } محصول نیاز به سفارش مجدد دارند`,
        //     icon: "mdi-alert-circle-outline",
        //     iconColor: "orange darken-2",
        //     bgColor: "orange lighten-5",
        //   },
        // ].filter(Boolean);
        this.totalStocks > 0
          ? {
              title: "موجودی کم",
              description: `${this.totalStocks} محصول نیاز به سفارش مجدد دارند`,
              icon: "mdi-alert-circle-outline",
              iconColor: "orange darken-2",
              bgColor: "orange lighten-5",
            }
          : null,
      ].filter(Boolean);
    },
  },
  mounted() {
    this.getLowStockProducts();
  },
  methods: {
    getLowStockProducts() {
      var app = this;
      app.loading = true;
      this.$axios
        .get(this.$endpoint + "dashboard/charts/product-in-order-point", {
          params: {
            dateType: "year",
          },
        })
        .then((response) => {
          let res = response.data.data;
          app.items = res;
          let StockList = app.items.map((item) => Number(item.stock) || 0);
          app.totalStocks = StockList.reduce((sum, value) => sum + value, 0);
        })
        .catch((err) => {
          app.loading = false;
        })
        .finally(() => {
          app.loading = false;
        });
    },
    buildAlert(title, data) {
      if (!data) return null;
      const isIncrease = data.trend === "increase";
      const percent = Math.abs(data.diffPercent);

      return {
        title,
        description: `${title.replace("عملکرد ", "")} این دوره ${percent}٪ ${
          isIncrease ? "افزایش" : "کاهش"
        } یافته است`,
        icon: isIncrease ? "mdi-trending-up" : "mdi-trending-down",
        iconColor: isIncrease ? "green darken-2" : "red darken-2",
        bgColor: isIncrease ? "green lighten-5" : "red lighten-5",
      };
    },
  },
};
</script>
